var map = {
	"./blue.png": "073f",
	"./bronzepawn.png": "710d",
	"./diamondcastling.png": "d5e4",
	"./goldking.png": "0537",
	"./goldqueen.png": "543a",
	"./green.png": "55d9",
	"./light-blue.png": "c261",
	"./light-green.png": "3f63",
	"./medievalking.png": "c32e",
	"./orange.png": "c571",
	"./platinumking.png": "cad1",
	"./platinumqueen.png": "4b95",
	"./purple.png": "4e25",
	"./rainbowbishop.png": "75da",
	"./rainbowrook.png": "6bce",
	"./red.png": "324d",
	"./silverknight.png": "0d0b",
	"./yellow.png": "0a71"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8a7b";